import React, {useEffect, useMemo, useState} from 'react';
import {FaLightbulb, FaTimes} from 'react-icons/fa';
import {findRepContextualTips} from '../util/rep-contextual-tips';
import {useTranslation} from 'react-i18next';

const GLOBAL_STORAGE_KEY = 'rep-contextual-tip-last-shown';
const TIP_STORAGE_PREFIX = 'rep-contextual-tip-';
const GLOBAL_COOLDOWN = 24 * 60 * 60 * 1000;
const TIP_COOLDOWN = 30 * 24 * 60 * 60 * 1000;

const readTimestamp = key => {
  try {
    return Number(window.localStorage.getItem(key) || 0);
  } catch (error) {
    return 0;
  }
};

const saveTimestamp = (key, timestamp) => {
  try {
    window.localStorage.setItem(key, String(timestamp));
  } catch (error) {
    // Il suggerimento resta utilizzabile anche se il browser blocca localStorage.
  }
};

const RepContextualTip = ({pathname, role, openAssistant}) => {
  const {t, i18n} = useTranslation();
  const [visible, setVisible] = useState(false);
  const tips = useMemo(() => findRepContextualTips(pathname, role, i18n.language), [i18n.language, pathname, role]);
  const tip = useMemo(() => {
    const now = Date.now();
    return tips.find(item => now - readTimestamp(`${TIP_STORAGE_PREFIX}${item.key}`) >= TIP_COOLDOWN) || null;
  }, [tips]);

  useEffect(() => {
    setVisible(false);
    if (!tip || Date.now() - readTimestamp(GLOBAL_STORAGE_KEY) < GLOBAL_COOLDOWN) return undefined;
    const timer = window.setTimeout(() => {
      const now = Date.now();
      saveTimestamp(GLOBAL_STORAGE_KEY, now);
      saveTimestamp(`${TIP_STORAGE_PREFIX}${tip.key}`, now);
      setVisible(true);
    }, 7000);
    return () => window.clearTimeout(timer);
  }, [pathname, tip]);

  if (!visible || !tip) return null;

  return <aside className="rep-contextual-tip" role="status" aria-live="polite">
    <button type="button" className="rep-contextual-tip__close" onClick={() => setVisible(false)} aria-label={t('CLOSE_SUGGESTION')}><FaTimes/></button>
    <div className="rep-contextual-tip__icon"><FaLightbulb/></div>
    <div className="rep-contextual-tip__content">
      <strong>{tip.question}</strong>
      <span>{tip.detail}</span>
      <div>
        <button type="button" className="rep-contextual-tip__primary" onClick={() => openAssistant(tip.ask)}>{t('SHOW_ME_HOW')}</button>
        <button type="button" className="rep-contextual-tip__secondary" onClick={() => setVisible(false)}>{t('NOT_NOW')}</button>
      </div>
    </div>
  </aside>;
};

export default RepContextualTip;
